<template>
  <f7-popup
    class="packaging-palletizing-popup"
    :opened="openPopup"
    @popup:closed="closePopup()"
  >
    <f7-page class="page">
      <f7-navbar
        sliding
        no-shadow
        :title="$t('common.assemblies')"
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link
            class="margin-right"
            @click="closePopup()"
          >
            <img :src="icClose">
          </f7-link>
        </f7-nav-right>
      </f7-navbar>

      <div class="div-frmConfectionsPalletizing">
        <f7-row>
          <f7-col width="33">
            <UCSearchEntityERP
              ref="UCClient"
              :title="$t('common.customer')"
              :placeholder="$t('common.customer')"
              :search-text="$t('searchEntity.client.searchText')"
              :search-cancellation-text="$t('searchEntity.client.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.client.searchNotFoundText')"
              :procedure-for-search="clientProcedure"
              :property-entity-shown-input="['Nombre']"
              :property-entity-shown-list-title="['Nombre']"
              :property-entity-shown-list-subtitle="['Codigo']"
              :min-text-search="0"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              @selection="EventclienteSelected"
            />
          </f7-col>
          <f7-col width="33">
            <UCSearchEntityERP
              ref="UCFamiliaArticulo"
              :title="$t('searchEntity.articleFamily.title.productFamily')"
              :placeholder="$t('searchEntity.articleFamily.placeholder.productFamily')"
              :search-text="$t('searchEntity.articleFamily.searchText')"
              :search-cancellation-text="$t('searchEntity.articleFamily.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.articleFamily.searchNotFoundText')"
              :end-point-for-list="obtenerFamiliaArticulos"
              :end-point-for-code-search="obtenerFamiliaArticulos"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre']"
              :min-text-search="0"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              @selection="eventFamilyArticlesSelected"
            />
          </f7-col>
          <f7-col width="33">
            <UCSearchEntityERP
              ref="UCAticulosDeUnaFamilia"
              :title="$t('common.product')"
              :placeholder="$t('common.product')"
              :search-text="$t('searchEntity.product.searchText')"
              :search-cancellation-text="$t('searchEntity.product.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.product.searchNotFoundText')"
              :end-point-for-list="obtenerArticuloFamilia"
              :end-point-for-code-search="obtenerArticuloFamilia"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre', 'Descripcion']"
              :pre-property-entity-shown-list-subtitle="[
                `${$t('common.name')}: `,
                `${$t('common.description')}: `,
              ]"
              :min-text-search="0"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              :search-in="['.item-title', '.subtitle0', '.subtitle1']"
              @selection="eventArticleSelected"
            >
              <template #subtitle-2="{ item }">
                <div>
                  {{ item.Descripcion }}
                </div>
              </template>
            </UCSearchEntityERP>
          </f7-col>
        </f7-row>
        <f7-row>
          <f7-col width="33">
            <UCSearchEntityERP
              ref="UCEnvases"
              :title="$t('common.package')"
              :placeholder="$t('common.package')"
              :search-text="$t('searchEntity.container.searchText')"
              :search-cancellation-text="$t('searchEntity.container.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.container.searchNotFoundText')"
              :end-point-for-list="obtenerEnvases"
              :end-point-for-code-search="obtenerEnvases"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre', 'Descripcion']"
              :pre-property-entity-shown-list-subtitle="[
                `${$t('common.name')}: `,
                `${$t('common.description')}: `,
              ]"
              :min-text-search="0"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              :search-in="['.item-title', '.subtitle0', '.subtitle1']"
              @selection="eventPackagingSelected"
            >
              <template #subtitle-2="{ item }">
                <div>
                  {{ item.Descripcion }}
                </div>
              </template>
            </UCSearchEntityERP>
          </f7-col>
          <f7-col width="33">
            <UCSearchEntityERP
              ref="UCTipoDePale"
              :title="$t('common.pallet')"
              :placeholder="$t('common.pallet')"
              :search-text="$t('searchEntity.pallet.searchText')"
              :search-cancellation-text="$t('searchEntity.pallet.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.pallet.searchNotFoundText')"
              :end-point-for-list="obtenerTipoDePale"
              :end-point-for-code-search="obtenerTipoDePale"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre', 'Descripcion']"
              :pre-property-entity-shown-list-subtitle="[
                `${$t('common.name')}: `,
                `${$t('common.description')}: `,
              ]"
              :min-text-search="0"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              :search-in="['.item-title', '.subtitle0', '.subtitle1']"
              @selection="eventPaleSelected"
            >
              <template #subtitle-2="{ item }">
                <div>
                  {{ item.Descripcion }}
                </div>
              </template>
            </UCSearchEntityERP>
          </f7-col>
          <f7-col width="33">
            <div class="content-checkbox-row">
              <label class="checkbox">
                <input
                  type="checkbox"
                  :checked="showGenerica"
                  @change="checkSowGenerica($event.target.checked)"
                >
                <i class="icon-checkbox" />
              </label>
              <span>
                {{ $t('production.palletizing.assemblies.includeGeneric') }}
              </span>
            </div>
          </f7-col>
        </f7-row>
      </div>
      <div class="container-acordeones content-accordeon-component">
        <div
          v-for="(confeccion, j) in confectionsFiltered"
          :key="j"
        >
          <UCAcordeon
            :items="[confeccion]"
            title-option="Estado"
            :show-badge="false"
            :opened-index="0"
            primary=" var(--his-light-blue)"
            font-color="var(--his-slate-blue)"
            :after-title="false"
            :show-checkbox="false"
          >
            <template #subOption="{ item }">
              <f7-list media-list>
                <f7-list-item
                  class="container-acordeones__item"
                >
                  <div class="item-title">
                    <label class="checkbox">
                      <input
                        type="checkbox"
                        :checked="item.checked"
                        @change="setCheckConfection(item, $event.target.checked)"
                      >
                      <i class="icon-checkbox" />
                    </label>
                    <span class="item-title__text">{{ `${item.Codigo} - ${item.Nombre}` }}</span>
                  </div>
                  <div class="item-subtitle">
                    <div class="display-flex">
                      <div
                        style="min-width: 6vw;"
                        class="item-subtitle__text1"
                      >
                        {{ `${$t('common.product')}:` }}
                      </div>
                      <div class="item-subtitle__text2">
                        {{ item.Producto?.Nombre }}
                      </div>
                    </div>
                  </div>
                  <div class="item-subtitle">
                    <div class="display-flex">
                      <div
                        style="min-width: 6vw;"
                        class="item-subtitle__text1"
                      >
                        {{ `${$t('common.package')}:` }}
                      </div>
                      <div class="item-subtitle__text2">
                        {{ item.Envase?.Nombre }}
                      </div>
                    </div>
                    <div
                      class="display-flex justify-content-space-between"
                      style="width: 160px; max-width: 180px;"
                    >
                      <div
                        class="item-subtitle__text1"
                      >
                        {{ `${$t('common.brand')}:` }}
                      </div>
                      <div class="item-subtitle__text2">
                        {{ item.Marca?.Nombre }}
                      </div>
                    </div>
                  </div>
                  <div class="item-subtitle">
                    <div class="display-flex">
                      <div
                        style="min-width: 6vw;"
                        class="item-subtitle__text1"
                      >
                        {{ `${$t('common.pallet')}:` }}
                      </div>
                      <div class="item-subtitle__text2">
                        {{ item.Palet?.Nombre }}
                      </div>
                    </div>
                    <div
                      class="display-flex justify-content-space-between"
                      style="width: 160px; max-width: 180px;"
                    >
                      <div
                        class="item-subtitle__text1"
                      >
                        {{ `${$t('common.packagesPerPallet')}:` }}
                      </div>
                      <div class="item-subtitle__text2">
                        {{ item.EnvasesPorPalet }}
                      </div>
                    </div>
                  </div>
                </f7-list-item>
              </f7-list>
            </template>
          </UCAcordeon>
        </div>
      </div>
      <div class="div-btn">
        <f7-button
          small
          fill
          class="div-btn__confirmar"
          @click="emitConfectionSelected()"
        >
          {{ $t('common.confirm') }}
        </f7-button>
      </div>
    </f7-page>
  </f7-popup>
</template>

<script>
import { mapState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { Log } from '@/js/common/HIDebuggingSupport';
import ConexionTA, {
  callObtenerArticulos,
  callObtenerFamiliasDeArticulos,
} from '@/js/services/traceability/APITraceability';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import icClose from '@/static/icons/ic_close.svg';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import { PreloaderGH } from '@/js/common/HINotificationSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import { TipoArticulo } from '@/js/common/enum';

/** @import { SPApp } from '@erpagroapp/types' */

export default {
  name: 'FrmConfectionsForPalletizing',
  components: {
    UCSearchEntityERP,
    UCAcordeon,
  },

  emits: [
    'confection-selected',
  ],

  data() {
    return {
      openPopup: false,
      icClose,
      productFamily: null,
      articleTypeProduct: null,
      itemOfPackaging: null,
      articleTypePale: null,
      confectionsForClient: [],
      confectionsFiltered: [],
      clientSelected: null,
      showGenerica: false,
    };
  },
  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-steel-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },
    clientProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_ClientesXIdGrupoEmpresarial',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa?.Id },
          { NombreParametro: 'fechaComprobacionBloqueos', Valor: new Date() },
          { NombreParametro: 'idSujetoVendedor', Valor: 0 },
        ],
        EntidadMapear: 'Comun.ClienteJSON',
      });
    },
  },

  methods: {
    /**
     * @public
     * @returns {Promise<void>}
     */
    async open(client) {
      Log(this, this.open.name);
      this.openPopup = true;
      if (client !== null && client !== undefined) {
        this.getConfectionsByClient(client);
      } else {
        this.getConfections(0);
        this.showGenerica = true;
      }
    },
    closePopup() {
      Log(this, this.closePopup.name);
      this.openPopup = false;
      this.clientSelected = null;
      this.confectionsForClient = [];
      this.confectionsFiltered = [];
      this.showGenerica = false;
      this.$refs.UCClient.Clear();
      this.$refs.UCFamiliaArticulo.Clear();
      this.$refs.UCAticulosDeUnaFamilia.Clear();
      this.$refs.UCEnvases.Clear();
      this.$refs.UCTipoDePale.Clear();
    },
    EventclienteSelected(value) {
      Log(this, this.EventclienteSelected.name);
      if (value !== null) {
        this.clientSelected = value;
        this.getConfections(this.clientSelected.Id);
      } else {
        this.confectionsForClient = [];
        this.confectionsFiltered = [];
        this.$refs.UCFamiliaArticulo.Clear();
        this.$refs.UCAticulosDeUnaFamilia.Clear();
        this.$refs.UCEnvases.Clear();
        this.$refs.UCTipoDePale.Clear();
        if (this.openPopup !== false) {
          this.getConfections(0);
        }
        this.showGenerica = true;
      }
    },
    eventFamilyArticlesSelected(obj) {
      Log(this, this.eventFamilyArticlesSelected.name);
      this.productFamily = obj;
      this.filterConfections();
    },
    eventArticleSelected(obj) {
      Log(this, this.eventArticleSelected.name);
      this.articleTypeProduct = obj;
      this.filterConfections();
    },
    async eventPackagingSelected(obj) {
      Log(this, this.eventPackagingSelected.name);
      this.itemOfPackaging = obj;
      this.filterConfections();
    },
    eventPaleSelected(obj) {
      Log(this, this.eventPaleSelected.name);
      this.articleTypePale = obj;
      this.filterConfections();
    },
    checkSowGenerica(value) {
      Log(this, this.checkSowGenerica.name);
      this.showGenerica = value;
      this.filterConfections();
    },
    setCheckConfection(item, value) {
      Log(this, this.setCheckConfection.name);
      this.confectionsFiltered.forEach((element) => {
        element.items.forEach((confection) => {
          if (confection.Id === item.Id) {
            confection.checked = value;
          } else {
            confection.checked = false;
          }
        });
      });
    },
    filterConfections() {
      Log(this, this.filterConfections.name);
      this.confectionsFiltered = [];
      let leakedConfections = this.confectionsForClient;

      if (this.productFamily !== null) {
        leakedConfections = leakedConfections.filter((confection) => confection.Producto.Familia.Id === this.productFamily.Id);
      }
      if (this.articleTypeProduct !== null) {
        leakedConfections = leakedConfections.filter((confection) => confection.Producto.Id === this.articleTypeProduct.Id);
      }
      if (this.itemOfPackaging !== null) {
        leakedConfections = leakedConfections.filter((confection) => confection.Envase.Id === this.itemOfPackaging.Id);
      }
      if (this.articleTypePale !== null) {
        leakedConfections = leakedConfections.filter((confection) => confection.Palet.Id === this.articleTypePale.Id);
      }

      const confectionsGenerica = leakedConfections.filter((confection) => confection.Generica);
      const confectionsNoGenerica = leakedConfections.filter((confection) => !confection.Generica);

      if (confectionsGenerica.length > 0 && this.showGenerica) {
        confectionsGenerica.forEach((obj) => {
          obj.checked = false;
        });
        this.confectionsFiltered.push({
          Estado: 'Confección Generérica',
          items: confectionsGenerica,
        });
      }
      if (confectionsNoGenerica.length > 0) {
        confectionsNoGenerica.forEach((obj) => {
          obj.checked = false;
        });
        this.confectionsFiltered.push({
          Estado: confectionsNoGenerica[0].Cliente.Nombre || '',
          items: confectionsNoGenerica,
        });
      }
    },
    emitConfectionSelected() {
      Log(this, this.emitConfectionSelected.name);
      let confectionSelected = null;
      this.confectionsFiltered.forEach((element) => {
        element.items.forEach((confection) => {
          if (confection.checked) {
            confectionSelected = confection;
          }
        });
      });
      if (confectionSelected !== null) {
        this.$emit('confection-selected', confectionSelected);
        this.closePopup();
      }
    },

    obtenerArticuloFamilia(value) {
      Log(this, this.obtenerArticuloFamilia.name);
      if (this.productFamily !== null && value === undefined) {
        return ConexionTA.callObtenerArticulosMateriaPrimaDeUnaFamilia(this.productFamily.Id);
      }
      return callObtenerArticulos({
        tipoArticulo: TipoArticulo.Producto,
        codigoArticulo: value,
      });
    },
    /* familia de articulos */
    obtenerFamiliaArticulos(value) {
      Log(this, this.obtenerFamiliaArticulos.name);
      return callObtenerFamiliasDeArticulos({ codigoFamilia: value });
    },
    /* Envases */
    obtenerEnvases(value) {
      Log(this, this.obtenerEnvases.name);
      return callObtenerArticulos({
        tipoArticulo: TipoArticulo.Envase,
        codigoArticulo: value,
      });
    },
    /* tipo palet */
    obtenerTipoDePale(value) {
      Log(this, this.obtenerTipoDePale.name);
      return callObtenerArticulos({
        tipoArticulo: TipoArticulo.Palet,
        codigoArticulo: value,
      });
    },
    async getConfections(idClient) {
      Log(this, this.getConfections.name);
      PreloaderGH(true, false, this.$t('production.palletizing.assemblies.get.preloaderText'));
      await callExecuteSPERP(
        'APPERPAgro_ConfeccionesXClientes',
        [{ NombreParametro: 'IdCliente', Valor: idClient }],
        'Comun.ConfeccionJSON',
      ).then((result) => {
        if (result.status !== 200) {
          PreloaderGH(false);
          return;
        }
        this.confectionsForClient = result.data;
        this.filterConfections(this.confectionsForClient);
      });
      PreloaderGH(false);
    },
    async getConfectionsByClient(client) {
      Log(this, this.getConfectionsByClient.name);
      this.$refs.UCClient.SelectEntity(client, false);
      this.getConfections(client.Id);
    },

  },

};
</script>

<style lang="scss">
.packaging-palletizing-popup {
  --f7-popup-tablet-width: 700px;
  --f7-popup-tablet-height: 750px;

  .page {
    overflow: hidden;
    background-color: var(--f7-page-bg-color) !important;
  }

  label.item-checkbox input[type="checkbox"]:checked ~ .icon-checkbox,
  label.item-checkbox input[type="checkbox"]:checked ~ * .icon-checkbox,
  .checkbox input[type="checkbox"]:checked ~ i,
  label.item-checkbox input[type="checkbox"]:indeterminate ~ .icon-checkbox,
  label.item-checkbox input[type="checkbox"]:indeterminate ~ * .icon-checkbox,
  .checkbox input[type="checkbox"]:indeterminate ~ i {
    background-color: #66ba33;
    border-color: #66ba33;

    &::after {
      opacity: 0;
    }
  }

  .div-frmConfectionsPalletizing {
    --search-title-color: var(--his-oliva);
    --search-font-size: 14px;

    .row {
      margin-top: 5px;
      padding-left: 25px;
      padding-right: 25px;
    }

    .content-checkbox-row {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      background-color: var(--his-tierra-white);
      color: var(--his-oliva);
      font-size: 14px;
      width: 200px;
      height: 60px;

      span {
        padding-left: 5px;
      }
    }
  }

  .div-btn {
    bottom: 15px;
    position: absolute;
    display: flex;
    justify-content: center;
    width: 100%;

    &__confirmar {
      background-color: var(--his-steel-blue);
      width: 170px;
    }
  }

  .div-separador {
    width: 94%;
    bottom: 65px;
    position: absolute;
  }

  .content-accordeon-component {
    height: calc(100% - 35%);
    overflow: scroll;
    margin-top: 15px;

    .accordion-list {
      .accordion-item-opened {
        border: none;

        .media-list {
          border-bottom: 1px solid  var(--his-slate-blue);
        }

        .item-inner {
          .item-link {
            &::after {
              border-top: 0;
            }
          }
        }
      }

      .item-inner {
        .item-link {
          background-color: var(--his-plum-shadow);

          .item-title {
            color: #fff;
          }

          &::before {
            color: white !important;
          }
        }
      }
    }
  }

  .container-acordeones {
    &__item {
      .item-title {
        display: flex;
        color: var(--his-steel-blue);
        font-weight: 600;
        font-size: 18px;

        &__text {
          margin-left: 10px;
        }
      }

      .item-subtitle {
        display: flex;
        justify-content: space-between;
        padding-right: 20px;
        margin-top: 10px;

        // max-width: 65vw;
        &__text2 {
          color: var(--his-plum-haze);
          font-size: 16px;
          font-weight: 500;
        }

        &__text1 {
          color: var(--his-steel-blue);
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
